<template>
  <div class="modal is-active">
    <div class="modal-background" @click="emitClose"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ currentProduct.name }} - Zulassungen</p>
        <button class="delete" aria-label="close" @click="emitClose"></button>
      </header>
      <section class="modal-card-body">
        <div v-if="currentProduct.approvalDrawing">
          <embed :src="currentProduct.approvalDrawing" frameborder="0" width="100%" height="750px">
        </div>
        <div v-else>
            <p>Keine Daten</p>
          </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    currentProduct () {
      return this.$store.state.currentProduct
    },
  },
  methods: {
    emitClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
